import {Component, OnInit} from '@angular/core';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {ActivatedRoute} from '@angular/router';
import {ReservationsHttpService} from '../../../../services/http-services/reservations/reservations-http.service';

@Component({
  selector: 'app-single-reservation',
  templateUrl: './single-reservation.component.html',
})
export class SingleReservationComponent implements OnInit {
  urlParams = {reservationId: null};
  reservationData: any;
  isPresentsRefundModalOpen = false;
  isAllPagePresentChecked = false;
  checkedPresentIds: number[] = [];
  currentPagePresentIds: any[] = [];
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  constructor(private activatedRoute: ActivatedRoute,
              private reservationsHttpService: ReservationsHttpService) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(res => {
      if (res.reservationId) {
        this.checkedPresentIds = [];
        this.urlParams.reservationId = res.reservationId;
        this.getSingleReservationData();
      }
    });
  }

  getSingleReservationData(): void {
    this.reservationsHttpService.getSingleReservation(this.urlParams).then((res: any) => {
      this.reservationData = res.data;
      this.currentPagePresentIds = res.data.gifts?.map((present: any) => present.id);
      this.checkIsAllCurrentPagePresentChecked();
    });
  }

  exportWishlistPdf(): void {
    this.reservationsHttpService.getExportWishlistPdf(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/pdf') {
        const blobUrl = URL.createObjectURL(response);
        window.open(blobUrl, '_blank');
      } else {
        console.error('The fetched file is not a PDF');
      }
    });
  }

  exportWishlistExcel(): void {
    this.reservationsHttpService.getExportWishlistExcel(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const blobUrl = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'Lista_želja.xlsx';
        link.click();
        URL.revokeObjectURL(blobUrl);
      } else {
        console.error('The fetched file is not an Excel file');
      }
    });
  }

  onCheckAllPresentsChange(): void {
    this.isAllPagePresentChecked = !this.isAllPagePresentChecked;
    if (this.isAllPagePresentChecked) {
      this.checkedPresentIds = [...this.checkedPresentIds, ...this.currentPagePresentIds];
    } else {
      this.checkedPresentIds = this.checkedPresentIds.filter(presentId => !this.currentPagePresentIds.includes(presentId));
    }
  }

  onCheckPresent(presentId: number): void {
    const presentIndex = this.checkedPresentIds.findIndex(item => item === presentId);
    if (presentIndex === -1) {
      this.checkedPresentIds.push(presentId);
      this.checkIsAllCurrentPagePresentChecked();
    } else {
      this.checkedPresentIds.splice(presentIndex, 1);
      this.isAllPagePresentChecked = false;
    }
  }

  checkIsAllCurrentPagePresentChecked(): void {
    this.isAllPagePresentChecked = this.currentPagePresentIds.every(presentId => this.checkedPresentIds.includes(presentId));
  }

  isPresentChecked(presentId: number): boolean {
    return this.checkedPresentIds.includes(presentId);
  }

  onConfirmGiftsRefund(): void {
    this.isPresentsRefundModalOpen = false;
    this.isAllPagePresentChecked = false;
    this.checkedPresentIds = [];
  }
}
